/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `RecipientList.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { RecipientList } from "./RecipientList";

import { Project } from "./Project";
import { RecipientListUser } from "./RecipientListUser";
import { ScheduledReport } from "./ScheduledReport";

export abstract class RecipientListModel {
    id: number;
    createdAt: Dayjs;
    description: string | null;
    emails: string[] | null;
    name: string;
    projectId: number;
    updatedAt: Dayjs;
    project: Project | null | undefined;
    recipientListUsers: RecipientListUser[] | undefined;
    scheduledReports: ScheduledReport[] | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        description: string | null,
        emails: string[] | null,
        name: string,
        projectId: number,
        updatedAt: Dayjs,
        project: Project | null | undefined,
        recipientListUsers: RecipientListUser[] | undefined,
        scheduledReports: ScheduledReport[] | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.description = description;
        this.emails = emails;
        this.name = name;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.project = project;
        this.recipientListUsers = recipientListUsers;
        this.scheduledReports = scheduledReports;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): RecipientList {
        const newObject = new RecipientList(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["description"],
            json["emails"],
            json["name"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["recipient_list_users"]?.map((item: any) => RecipientListUser.fromApiObject(item, timezone)),
            json["scheduled_reports"]?.map((item: any) => ScheduledReport.fromApiObject(item, timezone))
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            description: this.description,
            emails: this.emails,
            name: this.name,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            recipient_list_users_attributes: this.recipientListUsers?.map((item) => item.toApiObject()),
            scheduled_reports: this.scheduledReports?.map((item) => item.toApiObject()),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): RecipientList {
        const clone = Object.create(this) as RecipientList;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
